import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28fe2388&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=28fe2388&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=28fe2388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_9d3e8444ee7ad6f099877d142dfca7ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe2388",
  null
  
)

export default component.exports